// Container Variants
export const containerVariants = {
    hidden: {
        opacity: 1,
    },
    visible: {
        opacity: 1,
        transition: {
            delayChildren: 0.3,
            staggerChildren: 0.3, // Daha uzun bir gecikme ekledim
        },
    },

};

// Item Variants
export const itemVariants = {
    hidden: {
        opacity: 0,
        y: 50,
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 30, // Daha düşük sertlik
            damping: 25,   // Daha yumuşak sönümleme
            duration: 1.2, // Biraz daha uzun süre
            ease: 'easeOut',
        },
    },

};

// Text Variants
export const textVariants = {
    hidden: {
        opacity: 0,
    },
    visible: {
        opacity: 1,
        transition: {
            type: 'spring',
            stiffness: 30, // Daha az sertlik
            damping: 25,   // Daha doğal sönümleme
            duration: 1.2, // Süreyi biraz artırdım
            ease: 'easeOut',
        },
    },

};

// Container with Stagger Children Variants
export const container = {
    hidden: { opacity: 1 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.15, // Çocuklar arasında daha yavaş geçiş
        },
    },

};

// Child Variants
export const child = {
    hidden: { opacity: 0 },
    visible: { 
        opacity: 1,
        transition: {
            duration: 0.8, // Daha yumuşak geçiş
            ease: 'easeOut',
        }
    },

};

// Image Variants
export const imageVariants = {
    hidden: {
        opacity: 0,
        scale: 1.1, // Hafif bir küçültme (çok abartılı değil)
    },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 1.5, // Daha uzun görünme süresi
            ease: 'easeOut',
        },
    },

};
